import { memo, useLayoutEffect } from 'react';
import { AppFrameProps, useAppFrame } from 'src/pages/AppFrameLayout';

export const AppFrameConfig: React.FC<Partial<AppFrameProps> & { id: string }> =
  // eslint-disable-next-line react/display-name
  memo(
    ({
      id,
      title,
      collapsedTitle,
      actions,
      row,
      frameOnly,
      drawerOpen,
      backButtonLinkTo,
      backButtonTitle,
      compactTitle,
      containerMaxWidth,
      bgcolor,
      children,
      disabled,
    }) => {
      const { set, delete: deleteConfig } = useAppFrame();

      useLayoutEffect(() => {
        set(
          {
            ...(title && { title }),
            ...(collapsedTitle && { collapsedTitle }),
            ...(actions && { actions }),
            ...(row && { row }),
            ...(frameOnly && { frameOnly }),
            ...(drawerOpen && { drawerOpen }),
            ...(compactTitle && { compactTitle }),
            ...(children && { children }),
            ...(containerMaxWidth && { containerMaxWidth }),
            ...(backButtonLinkTo && { backButtonLinkTo }),
            ...(backButtonTitle && { backButtonTitle }),
            ...(bgcolor && { bgcolor }),
            ...(disabled && { disabled }),
          },
          id
        );

        return () => {
          deleteConfig(id);
        };
      }, [
        title,
        collapsedTitle,
        actions,
        row,
        frameOnly,
        drawerOpen,
        compactTitle,
        containerMaxWidth,
        backButtonLinkTo,
        children,
        set,
        id,
        deleteConfig,
        backButtonTitle,
        bgcolor,
        disabled,
      ]);

      return null;
    }
  );
